<template>
  <tr
    class="party-row"
    :key="byPartyTab"
  >
    <td style="position: relative; padding: 0;">
      <div
        class="map-key-rect"
        :style="
          `background-color: ${getPartyColor(item.party)};`
        "
      ></div>
      <div
        class="results-table-row-background"
        :style="
          `background-color: ${getPartyColor(
            item.party
          )}; width: ${barWidth}px;`
        "
      ></div>
    </td>
    <td class="party">
      {{ party.name }}
    </td>
    <td class="vote-perc">
      {{ parseFloat(item[`${byPartyTab}_pct_21`] || 0).toFixed(1) }}
    </td>
    <td class="change">
      <div
        class="change-chip"
        :style="
          `background-color: ${getSeatChangeColor(item[`${byPartyTab}_pct_delta`])};`
        "
      >
        {{ parseFloat(item[`${byPartyTab}_pct_delta`] || 0).toFixed(1) }}
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'

import { ConfigMixin, TableMixin } from '@/mixins'

export default {
  mixins: [
    ConfigMixin,
    TableMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    },
    party: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    barWidth: 0
  }),
  computed: {
    ...mapGetters({
      byPartyTab: 'results/byPartyTab'
    })
  },
  methods: {
    getBarWidth () {
      const row = document.getElementsByClassName('party-row')
      if (row.length === 0) return
      const rowWidth = row[0].offsetWidth - 100
      const barWidth = rowWidth * (parseFloat(this.item[`${this.byPartyTab}_pct_21`]) / 100)
      this.barWidth = barWidth
    }
  },
  mounted () {
    this.getBarWidth()
  },
  updated () {
    this.getBarWidth()
  }
}
</script>

<style>
.results-table-row-background {
  transition: width 0.7s ease-in-out;
}
</style>
